var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
function challengeQuery(filter) {
    const params = new URLSearchParams();
    if (filter === null || filter === void 0 ? void 0 : filter.status)
        params.set('status', filter.status);
    if (filter === null || filter === void 0 ? void 0 : filter.includeArchived)
        params.set('includeArchived', 'true');
    const qs = params.toString();
    return qs ? `?${qs}` : '';
}
export function getChallenges(filter) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/challenges${challengeQuery(filter)}`);
    });
}
export function getChallengeById(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/challenges/${id}`);
    });
}
export function getChallengeStats() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/challenges/stats');
    });
}
export function createChallenge(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post('/challenges', data);
    });
}
export function updateChallenge(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/challenges/${id}`, data);
    });
}
export function archiveChallenge(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.delete(`/challenges/${id}`);
    });
}
export function restoreChallenge(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.patch(`/challenges/${id}/restore`, {});
    });
}
export function deleteChallengePermanently(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.delete(`/challenges/${id}/permanent`);
    });
}
// Creator takes a challenge — returns the created (or existing) entry level.
export function participateInChallenge(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post(`/challenges/${id}/participate`, {});
    });
}
